import { formttedDate, showHyphen } from "@/lib/hyphen";
import OrderDrawer from "../OrderDrawer/OrderDrawer";
import { Button, Tooltip } from "@mui/material";
import AuthService from "@/services/api/auth/auth";


export const renderStatus = (status: string) => {
    if (!status) return "—";

    const normalized = status.toLowerCase();

    const styleMap: Record<string, string> = {
      approved: "text-green-600 bg-green-50",
      pending: "text-yellow-600 bg-yellow-50",
      delivered: "text-blue-600 bg-blue-50",
      rejected: "text-red-600 bg-red-50",
      partialdelivered: "text-purple-600 bg-purple-50",
      accept: "text-green-600 bg-green-50",
      reject: "text-red-600 bg-red-50",
    };

    const labelMap: Record<string, string> = {
      partialdelivered: "Partial Delivered",
      accept : "Approved",
      reject : "Rejected"
    };

    return (
      <span
        className={`px-2 py-1 rounded-md text-sm font-medium ${styleMap[normalized] || "text-gray-600 bg-gray-50"
          }`}
      >
        {labelMap[normalized] || status}
      </span>
    );
  };


export const createOrderColumns = (
  openDrawer: (content: React.ReactNode) => void,
  StatusCheck: (
    action: "ACCEPT" | "REJECT",
    row: any,
    rejectionReason?: string
  ) => void,
  onDeliver?: (row: any) => void
) => {

  const AllOrders = [
    {
      name: "Order No",
      selector: (row: any) => (
        <span
          className="cursor-pointer text-blue-400"
          onClick={() => openDrawer(
            <OrderDrawer 
            orderId={row.id} 
            fetchOrderApi={AuthService.GetSpecificOrders} 
            isApproved={row.status === "Approved"}
            onDeliver={onDeliver} 
            retailerName={row.retailerName}
             />
          )}
        >
          {row.orderNumber}
        </span>
      ),
    },
    { name: "Order Date", selector: (row: any) => formttedDate(row.orderDate) },
    { name: "Retailer", selector: (row: any) => showHyphen(row.retailerName) },
    {
      name: "Retailer Email",
      selector: (row: any) => showHyphen(row.retailerEmail),
    },
    { name: "Item Qty", selector: (row: any) => showHyphen(row.totalQuantity) },
    {
      name: "Est. Delivery Date",
      selector: (row: any) => formttedDate(row.expectedDeliveryDate),
    },
    { name: "Status", selector: (row: any) => renderStatus(row.status) },
  ];

  const requestedColumns = [
    {
      name: "Order No",
      selector: (row: any) => (
        <span
          className="cursor-pointer text-blue-400"
          onClick={() => openDrawer(<OrderDrawer orderId={row.id} fetchOrderApi = {AuthService.GetSpecificOrders}/>)}
        >
          {row.orderNumber}
        </span>
      ),
    },
    { name: "Order Date", selector: (row: any) => formttedDate(row.orderDate) },
    {
      name: "Company Name",
      selector: (row: any) => showHyphen(row.companyName),
    },
    { name: "Item Qty", selector: (row: any) => showHyphen(row.totalQuantity) },
    { name: "Retailer", selector: (row: any) => showHyphen(row.retailerName) },
    {
      name: "Retailer Email",
      selector: (row: any) => showHyphen(row.retailerEmail),
    },
    {
      name: "Est. Delivery Date",
      selector: (row: any) => formttedDate(row.expectedDeliveryDate),
    },
    { name: "Status", selector: (row: any) => renderStatus(row.status) },
    {
      name: "Action",
      selector: (row: any) =>
        row.status === "Pending" ? (
          <div
            style={{ display: "flex", justifyContent: "center", gap: "10px" }}
          >
            <button
              style={{
                background: "#6570FC",
                cursor: "pointer",
                borderRadius: "6px",
                width: "67px",
                height: "32px",
                fontWeight: "600",
                color: "white",
                fontSize: "0.75rem",
              }}
              onClick={() => StatusCheck("ACCEPT", row)}
            >
              Accept
            </button>
            <button
              style={{
                background: "#FFFFFF",
                cursor: "pointer",
                borderRadius: "6px",
                width: "67px",
                height: "32px",
                border: "1px solid #6570FC",
                fontWeight: "600",
                color: "#6570FC",
                fontSize: "0.75rem",
              }}
              onClick={() => StatusCheck("REJECT", row)}
            >
              Reject
            </button>
          </div>
        ) : (
          <span style={{ color: "#888", fontSize: "0.75rem" }}>—</span>
        ),
    },
  ];

  const approvedColumns = [
    {
      name: "Order No",
      selector: (row: any) => (
        <span
          className="cursor-pointer text-blue-400"
          onClick={() => openDrawer(<OrderDrawer 
            orderId={row.id} fetchOrderApi = {AuthService.GetSpecificOrders} isApproved = {true}
            onDeliver={onDeliver}
            retailerName={row.retailerName}
          />)}
        >
          {row.orderNumber}
        </span>
      ),
    },
    { name: "Order Date", selector: (row: any) => formttedDate(row.orderDate) },
    {
      name: "Company Name",
      selector: (row: any) => showHyphen(row.companyName),
    },
    { name: "Item Qty", selector: (row: any) => showHyphen(row.totalQuantity) },
    { name: "Retailer", selector: (row: any) => showHyphen(row.retailerName) },
    {
      name: "Retailer Email",
      selector: (row: any) => showHyphen(row.retailerEmail),
    },
    {
      name: "Est. Delivery Date",
      selector: (row: any) => formttedDate(row.expectedDeliveryDate),
    },
    { name: "Status", selector: (row: any) => renderStatus(row.status) },
    // {
    //   name: "Action",
    //   selector: (row: any) => (
    //     <Button variant="outlined" onClick={() => onDeliver && onDeliver(row)}>
    //       Deliver
    //     </Button>
    //   ),
    //   button: true,
    // },
  ];

  const partaildeliveredColumns = [
    {
      name: "Order No",
      selector: (row: any) => (
        <span
          className="cursor-pointer text-blue-400"
          onClick={() => openDrawer(<OrderDrawer orderId={row.id} 
          fetchOrderApi = {AuthService.GetSpecificOrders} isApproved = {true}
          onDeliver={onDeliver}
          retailerName={row.retailerName}
          />)}
        >
          {row.orderNumber}
        </span>
      ),
    },
    { name: "Order Date", selector: (row: any) => formttedDate(row.orderDate) },
    {
      name: "Company Name",
      selector: (row: any) => showHyphen(row.companyName),
    },
    { name: "Item Qty", selector: (row: any) => showHyphen(row.totalQuantity) },
    { name: "Retailer", selector: (row: any) => showHyphen(row.retailerName) },
    {
      name: "Retailer Email",
      selector: (row: any) => showHyphen(row.retailerEmail),
    },
    {
      name: "Est. Delivery Date",
      selector: (row: any) => formttedDate(row.expectedDeliveryDate),
    },
    { name: "Status", selector: (row: any) => renderStatus(row.status) },
  ];

  const deliveredColumns = [
    {
      name: "Order No",
      selector: (row: any) => (
        <span
          className="cursor-pointer text-blue-400"
          onClick={() => openDrawer(<OrderDrawer 
            orderId={row.id} fetchOrderApi = {AuthService.GetSpecificOrders}/>)}
        >
          {row.orderNumber}
        </span>
      ),
    },
    { name: "Order Date", selector: (row: any) => formttedDate(row.orderDate) },
    {
      name: "Company Name",
      selector: (row: any) => showHyphen(row.companyName),
    },
    { name: "Item Qty", selector: (row: any) => showHyphen(row.totalQuantity) },
    { name: "Retailer", selector: (row: any) => showHyphen(row.retailerName) },
    {
      name: "Retailer Email",
      selector: (row: any) => showHyphen(row.retailerEmail),
    },
    {
      name: "Est. Delivery Date",
      selector: (row: any) => formttedDate(row.expectedDeliveryDate),
    },
    { name: "Status", selector: (row: any) => renderStatus(row.status) },
  ];

  const declinedColumns = [
    {
      name: "Order No",
      selector: (row: any) => (
        <span
          className="cursor-pointer text-blue-400"
          onClick={() => openDrawer(<OrderDrawer orderId={row.id} fetchOrderApi = {AuthService.GetSpecificOrders}/>)}
        >
          {row.orderNumber}
        </span>
      ),
    },
    { name: "Order Date", selector: (row: any) => formttedDate(row.orderDate) },
    {
      name: "Company Name",
      selector: (row: any) => showHyphen(row.companyName),
    },
    { name: "Item Qty", selector: (row: any) => showHyphen(row.totalQuantity) },
    { name: "Retailer", selector: (row: any) => showHyphen(row.retailerName) },
    {
      name: "Retailer Email",
      selector: (row: any) => showHyphen(row.retailerEmail),
    },
    {
      name: "Est. Delivery Date",
      selector: (row: any) => formttedDate(row.expectedDeliveryDate),
    },
    { name: "Status", selector: (row: any) => renderStatus(row.status) },
  ];

  return {
    AllOrders,
    requestedColumns,
    approvedColumns,
    partaildeliveredColumns,
    deliveredColumns,
    declinedColumns,
  };
};
